export default {
  extraSmall: "30em", // 480px
  smaller: "40em", // 640px
  small: "48em", // 768px
  medium: "60em", // 960px
  large: "80em", // 1280px
  extraLarge: "100em" // 1600px
};

export const maxWidthBreakpoint = {
  small: "767px",
  medium: "1024px"
};



// WEBPACK FOOTER //
// ./styles/settings/breakpoints.js